import React, { lazy, Suspense } from 'react'
import isEmpty from 'lodash/isEmpty'
import { Tabs, Tab, Modal, Form, Button, Row } from 'react-bootstrap'
import { observable } from 'mobx'
import TagManager from 'react-gtm-module'
import { i18nTranslate, convertToBoolean } from 'src/utils'
import { getSubscriptionPaymentPayloadData } from 'src/utils/paymentContainerHelper'
import { observer } from 'mobx-react'
import {
  addressContainer,
  checkoutContainer,
  customerContainer,
  tokenExContainer,
  paymetricContainer,
  paypalContainer,
  subscriptionContainer,
  storeContainer,
} from 'src/models'
import {
  ShippingAddressSuggestionModal,
  toastState,
  AddressValidation,
  PaymentMarketForm,
  overlayState,
  Pagination,
} from 'src/views/components'
import {
  showLocationDetails,
  IS_BROWSER,
  getConvertedMonth,
  getNamefromFirstname,
  application,
  enableBillingAddressRequired,
} from 'src/utils'
import { checkIfCardIsExpired, handleAddressValidation } from 'src/deps'
import { APPConfig } from 'config/appConfig'
import { alertMessageKeys } from 'src/views/components/CartBlock/fixture'
import {
  evaluateAddressValidationResponse,
  getAddressValidationFormData,
  getAddressValidationRequest,
  removeShippingAddressFormValidationMeta,
  shouldMakeLegacyAddressValidationApiCall,
} from 'src/views/components/CommonFormForCS/shippingAddressFormValidation'

@observer
class ShippingEditingModal extends React.Component {
  @observable addAddrsBtnDisable = false
  @observable show = true
  @observable selectedIndex = -1
  @observable prefillData = ''
  @observable isCallInProgress = false
  @observable isToMakeLocationCall = false
  @observable selectedShippingMethod = {}
  @observable pickUpLocationResponse = {}
  @observable commonState = {
    show: false,
    flag: false,
    recommendations: [],
    formDataEnter: {},
    selectedAddress: {},
    addressInvalidFlag: false,
    params: {},
  }
  @observable activeTabKey = 'savedAddress'
  @observable paymentExistFlag = false
  @observable isToShowBillingAddressWarningModal = false
  @observable selectedPaymentForBillingAddData = false

  /**
   * @description Returns the appropriate payment container based on Paymetric flag
   * @returns {Object} tokenExContainer or paymetricContainer
   */
  getPaymentContainer = () => {
    const enableDirectPaymetricAndAccertifyIntegration = convertToBoolean(
      APPConfig.getAppConfig().enableDirectPaymetricAndAccertifyIntegration
    )
    return enableDirectPaymetricAndAccertifyIntegration
      ? paymetricContainer
      : tokenExContainer
  }

  newAddressData = ''
  resetEditAddressForm = ''
  transitDays = ''
  isRadioOptionChanged = false
  shortName = ''
  deliveryPeriod = ''
  paymentMethod = ''
  accountFormData = ''
  setToDefaultPayment = ''
  cardFullName = ''
  cardNickName = ''

  AddressForm = ''
  currentMarket = storeContainer?.defaultShippingRegion
    ? 'Address' + storeContainer?.defaultShippingRegion
    : 'AddressUS'
  AddressForm = lazy(
    () =>
      import(
        'src/views/addresses/' + this.currentMarket + '/' + this.currentMarket
      )
  )

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { selectedId = '' } = this.props
    selectedId && this.updateSelectedIndex(selectedId)
    /*if (this.props.isForShippingMethod || this.props.isForShippingAddress) {
      checkoutContainer.getShippingMethodDisclaimers()
    }*/
  }

  showOrderFrozenToast = () => {
    toastState.setToastMessage(
      i18nTranslate(
        'subscription.editFreezeErrorMessage',
        ' This subscription order is currently being processed and at this time no changes will be allowed. Please return after your subscription order has shipped to make any changes to your next order.'
      ),
      false,
      9000
    )
  }

  handleSelection = (address, index) => {
    const isBillingAddressRequired = enableBillingAddressRequired()
    if (
      address?.billingAddress === undefined &&
      isBillingAddressRequired &&
      this.props?.isForPaymentMethod === true
    ) {
      this.isToShowBillingAddressWarningModal = true
      this.selectedPaymentForBillingAddData = { address: address, index: index }
    } else {
      this.selectedIndex = index
      this.paymentExistFlag = true
      this.selectedShippingMethod = address
      this.transitDays = address?.properties?.deliveryEstimate || ''
      this.transitDays =
        this.transitDays.toLowerCase() === 'none' ? '0' : this.transitDays
      this.shortName = (address?.properties?.shortName || '').toLowerCase()
      this.deliveryPeriod = address?.description || ''
      this.deliveryPeriod =
        this.deliveryPeriod.toLowerCase() === 'none' ? '0' : this.deliveryPeriod
      this.isRadioOptionChanged = true
      this.pickUpLocationResponse = {}
      this.makePickUpLocationCall(this.selectedShippingMethod)
    }
  }

  makePickUpLocationCall = async selectedMethod => {
    this.isCallInProgress = true
    const { properties = {} } = selectedMethod
    const bopisValue = properties?.BOPIS || false
    const locationCode = properties?.locationCode || ''
    this.isToMakeLocationCall = bopisValue === true && locationCode !== ''

    if (this.isToMakeLocationCall === true) {
      this.pickUpLocationResponse =
        await checkoutContainer.getPickUpLocations(locationCode)
    }
    this.isCallInProgress = false
  }

  removeEllipsis = addressLine => {
    //  test 1 ... 99 S 1 ... 100 Ave --> test 1 S 1 Ave
    // ' ... 99' and ' ... 100' will be removed
    const splittedAddress = addressLine.split(' ... ')
    // splittedAddress = ['test 1','99 S 1', '100 Ave']
    // excluding index=0,
    // '99' in '99 S 1' , '100' from '100 Ave' has to removed
    const ellipsisSuffixRemoved = splittedAddress.map(
      (splittedValue, index) => {
        if (index > 0) {
          const splittedBasedOnSpace = splittedValue.split(' ')
          // splittedBasedOnSpace = ['99','S','1']
          splittedBasedOnSpace.splice(0, 1)
          // splittedBasedOnSpace = ['S','1']
          return splittedBasedOnSpace.join(' ')
          // 'S 1'
        } else {
          return splittedValue
        }
      }
    )
    //ellipsisSuffixRemoved =  ['test 1','S 1', 'Ave']
    return ellipsisSuffixRemoved.join(' ')
    // address.addressLine1 = test 1 S 1 Ave
  }
  checkAndRemoveEllipsis = address => {
    if (address.addressLine1 && address.addressLine1.includes('...')) {
      address.addressLine1 = this.removeEllipsis(address.addressLine1)
    }
    if (address.addressLine2 && address.addressLine2.includes('...')) {
      address.addressLine2 = this.removeEllipsis(address.addressLine2)
    }
    return address
  }

  getSuggestionListView = () => {
    const defaultCountry = storeContainer?.defaultShippingRegion || ''
    let addressList = this.props.isForPaymentMethod
      ? this.props.recommendations?.payments || []
      : this.props.recommendations || []
    const filteredAddress =
      addressList && this.props.isForShippingAddress
        ? addressList?.filter(
            data =>
              data?.country === defaultCountry && data?.type === 'shipping'
          )
        : addressList
    const selectedId = this.props.selectedId || '0'
    const selectedAddressIdForShipping = this.props.selectedAddressId || ''
    const isForShippingMethod = this.props.isForShippingMethod || false
    const isForPaymentMethod = this.props.isForPaymentMethod || false

    /**
     * @todo
     * Below lines of code to be moved to componentDidMount
     * as calling of getSubscriptionsPreferenceShippingMethods - API should not be placed inside of a function called from render.
     * when shipping methods are not available from prefernce API, below lines are executing
     * at the time we getting ApplicationStore.isAppLoading mobx console error
     */
    let addressForShippingMethods = {}
    if (isForShippingMethod && !(filteredAddress?.length > 0)) {
      addressForShippingMethods = addressContainer.addressData.find(
        (addressReceived, index) => {
          const id =
            addressReceived?.id ||
            addressReceived?.addressId ||
            addressReceived?.shippingMethodId ||
            ''
          if (parseInt(id) === parseInt(selectedAddressIdForShipping)) {
            return true
          }
        }
      )
      subscriptionContainer.getSubscriptionsPreferenceShippingMethods(
        customerContainer.userId,
        addressForShippingMethods
      )
    }

    return (
      filteredAddress?.length > 0 &&
      filteredAddress.map((addressReceived, index) => {
        const isForShippingAddress = this.props.isForShippingAddress || false
        const addressToModify = { ...addressReceived }
        if (
          isForShippingAddress &&
          addressToModify?.type &&
          addressToModify.type?.toLowerCase() === 'billing'
        ) {
          return ''
        }
        const address = this.checkAndRemoveEllipsis(addressToModify)
        const deliveryPeriods = address?.description || ''
        if (isForShippingMethod && !this.isRadioOptionChanged) {
          this.transitDays =
            selectedId == address.shippingMethodId
              ? address?.properties?.deliveryEstimate || ''
              : this.transitDays
          this.deliveryPeriod = deliveryPeriods
        }

        // Check if card is expired to update label
        const isCardExpired = checkIfCardIsExpired(
          addressToModify?.accountInfo?.expiryMonth,
          addressToModify?.accountInfo?.expiryYear
        )

        return (
          <>
            {((isForPaymentMethod &&
              (addressToModify?.type?.toLowerCase() === 'creditcard' ||
                addressToModify?.type?.toLowerCase() === 'debitcard')) ||
              !isForPaymentMethod) && (
              <>
                <div
                  id="block-inner"
                  key={'inner' + index}
                  role="radio"
                  tabIndex={0}
                  onClick={() => this.handleSelection(address, index)}
                  onKeyPress={() => this.handleSelection(address, index)}>
                  <Form.Check
                    className="my-2 custom-remove-inline address-data"
                    id={`savedAddress-${index}`}
                    key={index}
                    label={this.props.renderShippingAddressComponent(
                      address,
                      true,
                      false
                    )}
                    tabIndex={-1}
                    type="radio"
                    checked={
                      isForPaymentMethod
                        ? this.paymentExistFlag && index == this.selectedIndex
                        : index == this.selectedIndex
                    }
                    onChange={() => {
                      this.handleSelection(address, index)
                    }}
                    data-testid="qa-user-sub-saved-address-option"
                  />
                </div>
                {index == this.selectedIndex &&
                  this.isToMakeLocationCall &&
                  showLocationDetails(this.pickUpLocationResponse)}

                {/* Update expired card label */}
                {/* {isCardExpired && (
                  <div
                    onClick={e => {
                      this.toggleEditSubscriptionModal(e, addressToModify?.id)
                    }}
                    className="subscription-card-expired">
                    {i18nTranslate('payment.cardExpiredText', 'Card is expired')}{' '}
                    {addressToModify?.accountInfo?.expiryMonth} /{' '}
                    {addressToModify?.accountInfo?.expiryYear}
                  </div>
                )} */}
              </>
            )}
          </>
        )
      })
    )
  }

  // Toggle update card modal
  toggleEditSubscriptionModal = (e, id = 0) => {
    this.handleToggleView()
    // Call action to toggle
    this.props.toggleEditSubscriptionValue(e, id)
  }

  handleToggleView = () => {
    if (!this.isLimitShippingMethodEdit()) {
      this.show = !this.show
      this.props.toggleSuggestionView()
      customerContainer.addCreditCardvalidationFailed = false
    }
  }

  toggleAddressSuggestionView = () => {
    addressContainer.isRecommendationsVisible = false
    addressContainer.isShippingAddressSameAsBillingAddress = true
  }

  handleSelectSuggestion = async (
    newAddress,
    validateResponse,
    setDefaultShippingAddress
  ) => {
    this.isCallInProgress = true
    const toggleOnSubmit = this.props.toggleOnSubmit || true
    if (toggleOnSubmit) {
      this.handleToggleView()
    }
    this.props.isForShippingMethod && overlayState.toggleLoader()
    const addedAddress = {
      profileAddressId: validateResponse?.addressId || '',
      addressId: validateResponse?.addressId,
      ...newAddress,
    }
    if (newAddress) {
      await this.props.handleAddressContinue(
        addedAddress,
        true,
        this.isRadioOptionChanged,
        validateResponse,
        setDefaultShippingAddress
      )
      this.updateSelectedIndex(validateResponse?.addressId)
      this.isCallInProgress = false
      return false
    }
    const selectedRecommendation = this.props.isForPaymentMethod
      ? this.props.recommendations?.payments?.[this.selectedIndex] || []
      : this.props.recommendations?.[this.selectedIndex] || []
    const modifiedRecommendation =
      selectedRecommendation &&
      this.checkAndRemoveEllipsis(selectedRecommendation)
    await this.props.handleAddressContinue(
      modifiedRecommendation,
      true,
      this.isRadioOptionChanged
    )
    this.isCallInProgress = false
    this.props.isForShippingMethod && overlayState.toggleLoader()
  }
  updateSelectedIndex = selectedId => {
    const addressList = this.props.isForPaymentMethod
      ? this.props.recommendations?.payments || []
      : this.props.recommendations || []
    const isForShippingMethod = this.props.isForShippingMethod || false
    this.paymentExistFlag = false
    Array.isArray(addressList) &&
      addressList?.find((addressReceived, index) => {
        const id =
          addressReceived?.id ||
          addressReceived?.addressId ||
          addressReceived?.shippingMethodId ||
          ''

        if (isForShippingMethod) {
          if (id === selectedId) {
            this.selectedIndex = index
            this.selectedShippingMethod = addressReceived
            this.pickUpLocationResponse = {}
            this.makePickUpLocationCall(this.selectedShippingMethod)
          }
        } else if (parseInt(id) === parseInt(selectedId)) {
          this.selectedIndex = index
          this.paymentExistFlag = true
          return true
        }
      })
  }

  handleSubscriptionPaymentAddress = async (reqParams = {}) => {
    const isPaymentAddSuccess = await customerContainer?.addPayment(
      reqParams,
      true
    )
    const newPaymentId = customerContainer?.lastPaymentResponse?.id || ''
    if (customerContainer?.isSuccessResponse(isPaymentAddSuccess)) {
      if (typeof window === 'object') {
        window.scrollTo(0, 0)
      }
      this.handleToggleView()
      const response =
        await subscriptionContainer?.updateSubscriptionsPreference(
          customerContainer?.userId,
          {
            paymentId: newPaymentId,
          }
        )
      if (!subscriptionContainer?.isSuccessResponse(response)) {
        toastState.setToastMessage(response?.message)
      }
      await subscriptionContainer?.getAllSubscriptionsPreference(
        customerContainer?.userId
      )
    }
    this.handleClose()
  }

  handleClickOnPro = async (addressInfo, resetForm) => {
    let validateResponse = {}
    const setDefaultShippingAddress = Boolean(
      addressInfo?.setDefaultShippingAddress ?? addressInfo?.setDefaultAddress
    )
    const isAddressEdited = subscriptionContainer.isSuggestionSelected
      ? !this.checkAddressEdited(addressInfo)
      : true
    const selectedId = {
      addressId: this.props.selectedId || this.props.prefillData?.addressId,
    }
    overlayState.toggleLoader()
    if (addressInfo?.selectedIndex <= 0) {
      validateResponse = this.props?.prefillData?.addressId
        ? await addressContainer.validateUpdatedAddress(addressInfo, selectedId)
        : await addressContainer.validateOriginalAddress(
            addressInfo,
            'SubscriptionShipping'
          )
    } else {
      validateResponse = this.props?.prefillData?.addressId
        ? await addressContainer.updateAddress(addressInfo, selectedId)
        : await addressContainer.addAddress(addressInfo, 'SubscriptionShipping')
    }
    const recommendations =
      validateResponse?.validation?.[0]?.recommendations || []
    if (recommendations.length && !isEmpty(recommendations[0])) {
      this.newAddressData = addressInfo
      this.resetEditAddressForm = resetForm
      addressContainer.addressRecommendations = recommendations
      addressContainer.isRecommendationsVisible = true
      return false
    } else {
      this.resetEditAddressForm = ''
      this.newAddressData = ''
      this.handleSelectSuggestion(
        addressInfo,
        validateResponse,
        setDefaultShippingAddress
      )
    }
    overlayState.toggleLoader()
  }

  handlePaymentAddress = async addressInfo => {
    const {
      cardFirstName,
      cardNumber,
      expiryMonth,
      expiryYear,
      expiryDate,
      provider,
      setToDefaultPayment = false,
    } = this.accountFormData

    const { properties, provider: normalizedProvider } =
      getSubscriptionPaymentPayloadData({
        paymentContainer: this.getPaymentContainer(),
        paymetricContainer,
        provider,
        // Payload is saved as CREDITCARD, so the token field must stay paymetricToken.
        isGPSOptionResolved: true,
      })

    const reqParams = {
      type: 'CREDITCARD',
      accountInfo: {
        name: cardFirstName,
        lastName: cardFirstName,
        cardNumber,
        expiryMonth: expiryDate?.split('/')[0],
        expiryYear: '20' + expiryDate?.split('/')[1],
        provider: normalizedProvider,
        isDefault: setToDefaultPayment,
      },
      billingAddress: {
        ...addressInfo,
      },
      properties,
    }
    if (addressInfo?.selectedIndex <= 0) {
      const response =
        await addressContainer?.originalAddressApiCall(addressInfo)
      if (addressContainer?.isSuccessResponse(response)) {
        await this.handleSubscriptionPaymentAddress(reqParams)
      } else {
        if (response?.message === 'input.validation.failed') {
          response.message = alertMessageKeys(
            'Please correct the address to proceed.'
          )
        } else if (response?.code === 'ONESOURCE_ADPLGIN_VAL_ERROR') {
          response.message = i18nTranslate(
            'address.invalidAddress',
            'Address provided is invalid'
          )
        }
        toastState.setToastMessage(response?.message, false)
        return response
      }
    } else {
      await this.handleSubscriptionPaymentAddress(reqParams)
    }
  }

  handleContinue = async (formData, reqBody, params, isFromPayment) => {
    this.addAddrsBtnDisable = true
    try {
      const validationCountry = this.getValidationCountry(
        formData,
        reqBody,
        isFromPayment
      )
      const isToMakeAddressValidationApi =
        shouldMakeLegacyAddressValidationApiCall(formData, validationCountry)
      const cleanedFormData = removeShippingAddressFormValidationMeta(formData)
      const validationRequest = getAddressValidationRequest(formData, reqBody)
      const formDataTemp = getAddressValidationFormData(
        cleanedFormData,
        reqBody
      )

      if (isToMakeAddressValidationApi) {
        const res = await addressContainer.validateAddress(validationRequest)
        await this.processValidationResponse({
          res,
          formDataTemp,
          cleanedFormData,
          params,
        })
      } else {
        await this.handlePostValidationContinue(cleanedFormData)
      }
    } finally {
      this.addAddrsBtnDisable = false
    }
  }

  getValidationCountry = (formData, reqBody, isFromPayment) => {
    if (!isFromPayment) {
      return storeContainer?.defaultShippingRegion || ''
    }

    return (
      reqBody?.country ||
      formData?.country ||
      storeContainer?.defaultShippingRegion ||
      ''
    )
  }

  setValidationState = (formDataTemp, recommendationAddress, state = {}) => {
    this.commonState = {
      ...this.commonState,
      recommendations: [{ ...formDataTemp }, ...recommendationAddress],
      formDataEnter: { ...formDataTemp },
      addressInvalidFlag: false,
      ...state,
    }
  }

  handlePostValidationContinue = async cleanedFormData => {
    if (this.props.isSubscriptionPaymentEditButtonClicked) {
      await this.handlePaymentAddress(cleanedFormData)
    } else {
      await this.handleClickOnPro(cleanedFormData)
    }
  }

  processValidationResponse = async ({
    res,
    formDataTemp,
    cleanedFormData,
    params,
  }) => {
    const validationResult = evaluateAddressValidationResponse(
      res,
      formDataTemp,
      (currentAddress, firstAddress) =>
        handleAddressValidation(currentAddress, firstAddress)
    )

    if (validationResult.action === 'invalid_address') {
      this.commonState = {
        ...this.commonState,
        recommendations: validationResult.recommendations,
        formDataEnter: { ...formDataTemp },
        params: { ...params },
        addressInvalidFlag: true,
        show: true,
      }
      return
    }

    if (validationResult.action === 'onesource_error') {
      this.commonState = {
        ...this.commonState,
        show: false,
      }
      toastState.setToastMessage(
        i18nTranslate('address.NotAdded', 'Address not added')
      )
      return
    }

    this.setValidationState(
      formDataTemp,
      validationResult.recommendations.slice(1)
    )

    if (validationResult.action === 'show_recommendations') {
      this.setValidationState(
        formDataTemp,
        validationResult.recommendations.slice(1),
        {
          show: true,
        }
      )
      return
    }

    await this.handlePostValidationContinue(cleanedFormData)
  }

  handleClose() {
    this.commonState = {
      ...this.commonState,
      show: false,
    }
  }

  checkAddressEdited = formData => {
    const addressKeys = ['addressLine1', 'addressLine2', 'city', 'state', 'zip']
    const currentlySelectedAddress = this.prefillData
    let isAddressEdited = addressKeys.every(key => {
      const suggestedAddress =
        currentlySelectedAddress?.key || ''.trim().toLowerCase()
      const formAddress = formData?.key || ''.trim().toLowerCase()
      return suggestedAddress === formAddress
    })
    subscriptionContainer.isSuggestionSelected = isAddressEdited
    return isAddressEdited
  }
  findDefaultAddress = () => {
    const defaultaddressData = addressContainer.addressData.find(address => {
      if (address.isDefault === true) {
        return true
      }
    })
    return defaultaddressData || {}
  }

  onAddingPaymentCard = async cardDetail => {
    const {
      cardFirstName = '',
      cardLastName = '',
      cardFullName,
      cardNumber = '',
      expiryMonth,
      expiryYear,
      expiryDate = '',
      cardCVV = '',
      provider = '',
      setDefaultSubscriptionPayment = false,
      // isDefault,
      setToDefaultPayment = false,
      billingSameAsShipping,
      // isAddressDefault,
      paymentMethodType,
      bankName = '',
      accountType = '',
      routingNumber = '',
      accountNumber = '',
      ...addressParams
    } = cardDetail

    this.accountFormData = cardDetail

    this.paymentMethod = paymentMethodType
    if (
      paymentMethodType.toUpperCase() === 'PAYPALSUBSCRIPTION' &&
      !paypalContainer.isPaypalAccepted
    ) {
      toastState.setToastMessage(
        i18nTranslate('paypalpayment.setup', 'Paypal is not setup')
      )
      return
    }
    // billingSameAsShipping === true ? this.findDefaultAddress() : addressParams// CX121-2910
    // changing the address node for validation success// CX121-2910
    let isShippingAddress =
      subscriptionContainer.subscriptionPreferenceResponse.addresses || ''
    const billingAddress =
      billingSameAsShipping === true && isShippingAddress
        ? isShippingAddress
        : addressParams
    billingAddress.email = customerContainer.profileResponse.email
    billingAddress.addressLine1 = billingAddress?.street1
      ? billingAddress?.street1
      : billingAddress?.addressLine1 || ''
    billingAddress.addressLine2 = billingAddress?.street2
      ? billingAddress?.street2
      : billingAddress?.addressLine2 || ''
    billingAddress.stateList = billingAddress?.state
      ? billingAddress?.state
      : billingAddress?.stateList || ''
    billingAddress.zip = billingAddress?.zipCode
      ? billingAddress?.zipCode
      : billingAddress?.zip || ''
    delete billingAddress?.validated
    delete billingAddress?.validatedOn
    delete addressParams.undefined
    const params = {
      type: this.paymentMethod,
      isDefault: setToDefaultPayment,
      isDefaultSubscriptionPayment: setDefaultSubscriptionPayment,
    }
    const name = getNamefromFirstname(cardFirstName)
    if (
      this.paymentMethod === 'CREDITCARD' ||
      this.paymentMethod === 'DEBITCARD'
    ) {
      const { properties, provider: normalizedProvider } =
        getSubscriptionPaymentPayloadData({
          paymentContainer: this.getPaymentContainer(),
          paymetricContainer,
          provider,
          // Payload is saved as CREDITCARD/DEBITCARD, so keep paymetricToken.
          isGPSOptionResolved: true,
        })
      params.accountInfo = {
        name: name.firstName,
        lastName: name.lastName,
        cardNumber,
        expiryMonth: expiryDate?.split('/')[0],
        expiryYear: '20' + expiryDate?.split('/')[1],
        provider: normalizedProvider,
        isDefault: setToDefaultPayment,
      }
      params.billingAddress = billingAddress
      params.properties = properties
    } else if (this.paymentMethod === 'ACH') {
      params.properties = {
        bankName,
        firstNameOnAccount: cardFirstName,
        lastNameOnAccount: cardLastName,
        accountType,
        routingNumber,
        accountNumber,
      }
      params.billingAddress = billingAddress
    } else {
      if (typeof window === 'object') {
        window.scrollTo(0, 0)
      }
      const postData = {
        isDefault: this.setToDefaultPayment,
        name: paypalContainer.paypalDisplayName,
      }
      if (paypalContainer.isPaypalAccepted) {
        customerContainer.updatePayment(
          {
            id: paypalContainer.paymentId,
            postData,
          },
          'subscriptionPaymentEditingScreen'
        )
        await subscriptionContainer.updateSubscriptionsPreference(
          customerContainer.userId,
          {
            paymentId: paypalContainer.paymentId,
          }
        )
        await subscriptionContainer.getAllSubscriptionsPreference(
          customerContainer.userId
        )
      }

      this.handleToggleView()
      // return
    }

    if (!billingSameAsShipping) {
      const transformedFormData = addressParams || {}
      const newAddressData = {
        ...transformedFormData,
        default: true,
        street1: transformedFormData.addressLine1,
        street2: transformedFormData.addressLine2,
        zipCode: transformedFormData.zip || transformedFormData.postalCode,
        // country: storeContainer.storeIDValue,
      }
      delete newAddressData.undefined
      this.handleContinue(addressParams, newAddressData, params, true)
    } else {
      overlayState.toggleLoader()
      const isPaymentAddSuccess = await customerContainer.addPayment(
        params,
        true,
        true
      )
      const newPaymentId = customerContainer.lastPaymentResponse?.id || ''
      if (customerContainer.isSuccessResponse(isPaymentAddSuccess)) {
        /**
         * @info
         * GTM Datalayer -  Add payment in subscription
         */

        const { accountInfo, isDefault, type } = params || {}

        TagManager.dataLayer({
          dataLayer: {
            event: 'paymentAddedComplete',
            pagePath: '/myaccount/subscriptions',
            pageTitle: 'Payment Details',
            firstName: accountInfo?.name || '',
            lastName: accountInfo?.lastName || '',
            cardType: type || '',
            isDefault: isDefault || '',
            platform: 'equinox',
          },
        })

        if (typeof window === 'object') {
          window.scrollTo(0, 0)
        }
        this.handleToggleView()

        if (setDefaultSubscriptionPayment || setToDefaultPayment) {
          const response =
            await subscriptionContainer.updateSubscriptionsPreference(
              customerContainer.userId,
              {
                paymentId: newPaymentId,
              }
            )
          if (subscriptionContainer.isSuccessResponse(response)) {
            toastState.setToastMessage(
              i18nTranslate(
                'payment.subscriptionDefaultSuccess',
                'Payment method saved successfully and set as subscription default'
              ),
              true
            )
          } else {
            const errorCode = response?.responseCode || response?.code || ''
            const errorMessage =
              response?.responseMessage || response?.message || ''
            const editFreezeErrorCode =
              errorCode === 'error.subscription.editfreeze.date.reached'
            if (editFreezeErrorCode) {
              toastState.setToastMessage(
                i18nTranslate(
                  'subscription.editFreezeErrorMessage',
                  'This subscription order is currently being processed and at this time no changes will be allowed. Please return after your subscription order has shipped to make any changes to your next order.'
                )
              )
            } else {
              toastState.setToastMessage(errorMessage)
            }
          }
          const { updateSubscription } = this.props
          if (updateSubscription) {
            await updateSubscription()
          } else {
            let params = new URLSearchParams(window?.location?.search)
            const month = params?.get('month') || ''
            await subscriptionContainer.getAllSubscriptionsPreference(
              customerContainer.userId,
              month === 'showall' ? '' : month,
              month === 'showall' ? true : false
            )
          }
        } else {
          toastState.setToastMessage(
            i18nTranslate(
              'payment.subscriptionAddSuccess',
              'Payment method saved successfully'
            ),
            true
          )
        }
      }
      overlayState.toggleLoader()
    }
  }

  renderSubscriptionSubmitButton = () => {
    return (
      <Modal.Footer className="border-top">
        <Row noGutters className="justify-content-end w-100">
          <Button
            tabIndex={0}
            variant="outline-primary"
            className="nuskin-btn-size mr-md-3 semi-solid-button  rounded-0 mt-2 mt-md-0"
            onClick={this.handleToggleView}
            data-testid="qa-suggestion-close">
            {i18nTranslate('editShippingAddress.close', 'Close')}
          </Button>
          <Button
            tabIndex={0}
            // id="continueBtn"
            type="submit"
            disabled={this.addAddrsBtnDisable || false}
            className="continue-btn nuskin-btn-size semi-solid-button  rounded-0 mt-2 mt-md-0"
            variant="primary"
            data-testid="qa-suggestion-save">
            {i18nTranslate('editShippingAddress.continue', 'Continue')}
          </Button>
        </Row>
      </Modal.Footer>
    )
  }
  isOrderFrozen = () => {
    const date = new Date()
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'
    const lastOrderProcessedMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )
    const {
      freezeOrderDate = '',
      orderProcessingDate = '',
      lastProcessNowAttempt = '',
    } = subscriptionContainer.subscriptionPreferenceResponse || {}
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    let isCurrentMonthProcessAttempted = false
    if (lastProcessNowAttempt && lastProcessNowAttempt != 0) {
      const lastProcessAttemptedMonth =
        getConvertedMonth(lastProcessNowAttempt, timeZone) || ''
      const lastProcessAttemptedDate =
        new Date(lastProcessNowAttempt)?.getDate() || ''
      isCurrentMonthProcessAttempted =
        currentMonth === lastProcessAttemptedMonth &&
        lastProcessAttemptedDate >= freezeOrderDate
    } else {
      // when lastProcessNowAttempt is not available for a user
      // we need to check whether processing date is in past
      // in that case, we have to consider as process is attempted
      isCurrentMonthProcessAttempted = date.getDate() > orderProcessingDate
    }
    const isCurrentMonthSuccess =
      lastOrderProcessedMonth == currentMonth &&
      lastSubscriptionOrderStatus.toLowerCase() == 'order_success'

    return (
      !isCurrentMonthSuccess &&
      !isCurrentMonthProcessAttempted &&
      date.getDate() >= freezeOrderDate &&
      date.getDate() <= orderProcessingDate
    )
  }
  handlePagination = async (activePage = 1) => {
    await customerContainer.getPaymentsForDashboard(false, activePage)
    this.updateSelectedIndex(this.props.selectedId)
  }

  renderTabs = AddressForm => {
    const suggestionListView = this.getSuggestionListView()
    const savedAddress = i18nTranslate(
      'subscription.savedAddress',
      'saved address'
    )
    const newAddress = i18nTranslate(
      'subscription.addNewAddress',
      'add new address'
    )
    const savedPayment = i18nTranslate(
      'subscription.savedPayment',
      'saved payment'
    )
    const newPayment = i18nTranslate(
      'subscription.addNewPayment',
      'add new payment'
    )
    const {
      customSaveButtonLabel,
      recommendations = {},
      totalPagesLength = 1,
    } = this.props

    const saveChanges = i18nTranslate(
      'accountProfile.orgAddressSaveButton',
      'Save Changes'
    )
    const isPaymentPaginationEnabled =
      APPConfig?.getAppConfig()?.isPaymentPaginationEnabled === 'true' || false

    return (
      <Tabs
        className="mb-3 mt-2 address-tab-title subscription-tabs-wrapper text-capitalize"
        data-testid="qa-user-sub-saved-or-new-addresses"
        defaultActiveKey={'savedAddress'}
        activeKey={this.activeTabKey}
        onSelect={key => (this.activeTabKey = key)}
        id="">
        <Tab
          eventKey="savedAddress"
          tabClassName="tab-height"
          title={
            this.props.isSubscriptionPaymentEditButtonClicked
              ? savedPayment
              : savedAddress
          }
          data-testid="qa-address-container">
          {suggestionListView}
          {this.props.isForPaymentMethod &&
            totalPagesLength > 1 &&
            isPaymentPaginationEnabled && (
              <Pagination
                handlePagination={this.handlePagination}
                totalPages={totalPagesLength}
                active={recommendations?.pageableInfo?.page || 1}
                numOfPaginationsToShow={totalPagesLength}
                alignPagination={application.isMobile ? 'center' : 'start'}
              />
            )}
          <Modal.Footer>
            <Button
              variant="outline-primary"
              className="nuskin-btn-size mr-md-3 rounded-0 mt-2 mt-md-2"
              onClick={this.handleToggleView}
              data-testid="qa-sub-edit-address-close-btn">
              {i18nTranslate('shipping.closeButton', 'Close')}
            </Button>
            <Button
              variant="primary"
              className={`continue-btn nuskin-btn-size semi-solid-button rounded-0 mt-2 mt-md-2 ${
                customSaveButtonLabel?.length > 16 || saveChanges.length > 16
                  ? 'extend-btn'
                  : ''
              }`}
              onClick={() => {
                this.isOrderFrozen()
                  ? this.showOrderFrozenToast()
                  : this.handleSelectSuggestion()
              }}
              data-testid="qa-sub-edit-address-save-btn"
              disabled={this.isCallInProgress}>
              {`${customSaveButtonLabel ? customSaveButtonLabel : saveChanges}`}
            </Button>
          </Modal.Footer>
        </Tab>
        <Tab
          tabClassName="tab-height"
          eventKey="newAddress"
          title={
            this.props.isSubscriptionPaymentEditButtonClicked
              ? newPayment
              : newAddress
          }>
          {this.activeTabKey == 'newAddress' && (
            <>
              {this.props.isSubscriptionPaymentEditButtonClicked ? (
                <PaymentMarketForm
                  onSubmitForm={this.onAddingPaymentCard}
                  isPaymentEdit={true}
                  isFromEditSubscription={true}
                  includePaymetricCvv={false}
                  billingAddressType="subscription"
                  formType="subscription-market-form"
                />
              ) : (
                IS_BROWSER && (
                  <Suspense fallback="">
                    <AddressForm
                      shippingAddresses={recommendations}
                      onSubmit={
                        this.isOrderFrozen()
                          ? this.showOrderFrozenToast
                          : this.handleContinue
                      }
                      addressInfo={this.prefillData}
                      renderSubmitButton={this.renderSubscriptionSubmitButton}
                      type="subscription"
                    />
                  </Suspense>
                )
              )}
            </>
          )}
        </Tab>
      </Tabs>
    )
  }

  handleAddressSuggestionContinue = (address, isModal, isOriginal) => {
    this.newAddressData = {
      ...this.newAddressData,
      ...address,
    }
    if (isOriginal === 'original') {
      addressContainer.isQasValidated = false
      addressContainer.isSelfValidated = true
    } else {
      addressContainer.isQasValidated = true
      addressContainer.isSelfValidated = false
    }
    if (typeof this.resetEditAddressForm == 'function') {
      this.resetEditAddressForm()
    }
    subscriptionContainer.isSuggestionSelected = true
    this.prefillData = this.newAddressData
  }

  renderEditSubscriptionSubmitButton = () => {
    return (
      <Modal.Footer className="subs-edit-address border-top-0 justify-content-start pl-0">
        <Row noGutters className="justify-content-start w-100">
          <Button
            type="submit"
            className="continue-btn mr-md-3 nuskin-btn-size rounded-0 mt-2 mt-md-0 pl-3 pr-3"
            variant="primary"
            data-testid="qa-suggestion-save">
            {i18nTranslate('editShippingAddress.applyChanges', 'Apply Changes')}
          </Button>
          <Button
            variant="secondary"
            className="nuskin-btn-size btn-outline-primary rounded-0 mt-2 mt-md-0 pl-3 pr-3"
            onClick={this.handleToggleView}
            data-testid="qa-suggestion-close">
            {i18nTranslate('editShippingAddress.cancel', 'Cancel')}
          </Button>
        </Row>
      </Modal.Footer>
    )
  }

  isLimitShippingMethodEdit = () => {
    return (
      this.props?.handleLimitEditShippingMethod &&
      !this.props.handleLimitEditShippingMethod()
    )
  }

  render() {
    const suggestionListView = this.getSuggestionListView()
    const {
      customModalTitle,
      customSaveButtonLabel,
      renderTabs = false,
      isForShippingMethod = false,
    } = this.props
    const isToShowBillingAddressPopup =
      this.props?.isToShowBillingAddressWarningModal ??
      this.isToShowBillingAddressWarningModal
    return (
      <>
        <Modal
          aria-hidden={false}
          centered
          data-testid="qa-address-suggestion-overlay"
          show={this.show}
          key="address-suggestion-modal"
          className={addressContainer.isRecommendationsVisible ? 'd-none' : ''}
          onHide={this.handleToggleView}>
          <Modal.Header
            closeButton
            data-testid="qa-subscription-shipping-model-close-icon">
            <Modal.Title as="h4" className="mb-0">
              {customModalTitle
                ? customModalTitle
                : this.props.isExistingAddressEdit
                  ? i18nTranslate(
                      'subscription.EditExistingAddress',
                      'Edit Address'
                    )
                  : i18nTranslate('addressSuggestion.title', 'Suggestions')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body bsPrefix="suggestions-modal-body fix-nav-width">
            {this.props.isExistingAddressEdit && IS_BROWSER ? (
              <Suspense fallback="">
                <this.AddressForm
                  onSubmit={
                    this.isOrderFrozen()
                      ? this.showOrderFrozenToast
                      : this.handleContinue
                  }
                  addressInfo={
                    this.prefillData ? this.prefillData : this.props.prefillData
                  }
                  handleToggleView={this.handleToggleView}
                  type="subscription"
                  className="mt-3 px-4"
                  renderSubmitButton={this.renderEditSubscriptionSubmitButton}
                />
              </Suspense>
            ) : renderTabs ? (
              this.renderTabs(this.AddressForm)
            ) : (
              <>
                {this.isLimitShippingMethodEdit() && (
                  <div className="shipping-method-alert text-dark paragraph-s pb-3">
                    {i18nTranslate(
                      'dangerous_goods_subscription_item_shipping_limitation',
                      'Some items in your subscription might limit the shipping options.'
                    )}
                  </div>
                )}
                <div className="px-4">{suggestionListView}</div>
              </>
            )}
            {/*isForShippingMethod && this.renderShippingMethodDisclaimers()*/}
          </Modal.Body>
          {!renderTabs && (
            <Modal.Footer>
              <Button
                variant="secondary"
                disabled={this.isLimitShippingMethodEdit()}
                className="modal-button semi-solid-button text-uppercase rounded-0 mt-2 mt-md-2"
                onClick={this.handleToggleView}
                data-testid="qa-suggestion-close">
                {i18nTranslate('shipping.closeButton', 'Close')}
              </Button>
              <Button
                variant="primary"
                className="modal-button semi-solid-button text-uppercase rounded-0 mt-2 mt-md-2"
                onClick={() => this.handleSelectSuggestion()}
                data-testid="qa-suggestion-save"
                disabled={this.isCallInProgress || this.selectedIndex === -1}>
                {`${
                  customSaveButtonLabel
                    ? customSaveButtonLabel
                    : i18nTranslate(
                        'accountProfile.orgAddressSaveButton',
                        'Save Changes'
                      )
                }`}
              </Button>
            </Modal.Footer>
          )}

          {this.commonState.show && (
            <AddressValidation
              open={this.commonState.show}
              addressInvalidFlag={this.commonState.addressInvalidFlag}
              recommendations={this.commonState.recommendations}
              handleClose={() => this.handleClose()}
              handleClickOnPro={dataAfterValidation => {
                this.props.isSubscriptionPaymentEditButtonClicked
                  ? this.handlePaymentAddress(dataAfterValidation)
                  : this.handleClickOnPro(dataAfterValidation)
              }}
            />
          )}
        </Modal>

        {addressContainer.isRecommendationsVisible &&
          !this.props.isSubscriptionPaymentEditButtonClicked && (
            <ShippingAddressSuggestionModal
              recommendations={addressContainer.addressRecommendations}
              toggleSuggestionView={this.toggleAddressSuggestionView}
              renderShippingAddressComponent={address =>
                this.props.renderShippingAddressComponent(address, true)
              }
              handleAddressContinue={this.handleAddressSuggestionContinue}
              originalAddress={this.newAddressData}
            />
          )}
        <Modal
          show={isToShowBillingAddressPopup}
          onHide={() => (this.isToShowBillingAddressWarningModal = false)}
          backdrop="static"
          className="billing-address-warning-modal">
          <Modal.Title className="p-3">
            {i18nTranslate(
              'billingAddressWarning',
              'To use this payment method, you need to update the billing address. Can you proceed with the update?'
            )}
          </Modal.Title>
          <Modal.Body className="pt-0">
            <div className="d-flex justify-content-between">
              <Button
                data-testid="qa-yes-button"
                className="w-50 mr-2"
                variant="primary"
                type="submit"
                disabled={this.props.disableButton}
                onClick={() => {
                  this.isToShowBillingAddressWarningModal = false
                  this.isToShowEditUpdatePaymentModal = true
                  const { address, index } =
                    this.selectedPaymentForBillingAddData
                  this.selectedIndex = index
                  this.paymentExistFlag = true
                  this.selectedShippingMethod = address
                  this.transitDays = address?.properties?.deliveryEstimate || ''
                  this.transitDays =
                    this.transitDays.toLowerCase() === 'none'
                      ? '0'
                      : this.transitDays
                  this.shortName = (
                    address?.properties?.shortName || ''
                  ).toLowerCase()
                  this.deliveryPeriod = address?.description || ''
                  this.deliveryPeriod =
                    this.deliveryPeriod.toLowerCase() === 'none'
                      ? '0'
                      : this.deliveryPeriod
                  this.isRadioOptionChanged = true
                  this.pickUpLocationResponse = {}
                  this.makePickUpLocationCall(this.selectedShippingMethod)
                  this.props?.toggleEditPaymentModal(address?.id)
                }}>
                {i18nTranslate('yes', 'Yes')}
              </Button>
              <Button
                data-testid="qa-cancel-button"
                className="w-50 mr-2"
                variant="primary"
                onClick={() => {
                  this.isToShowBillingAddressWarningModal = false
                }}>
                {i18nTranslate('cancel', 'Cancel')}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}
export { ShippingEditingModal }
export default ShippingEditingModal
